import {IntermediatePart} from "../../intermediatePart";
import {PLACEMENTS} from "../../constants";
import DesignNavigationItem from "../../../../visComponents/designNavigationItem";

export default class Faucet extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'center_island_faucet';
    this.partName = 'Faucet';
    this.translateId = "visualizer.kitchen.center_island.center_island_faucet";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    dbFeature.metaData["RoomLayout"] = (dbFeature.metaData["RoomLayout"] && dbFeature.metaData["RoomLayout"].filter(roomLayout => roomLayout.includes("I"))) || [];
    if (dbFeature.metaData && dbFeature.metaData["Placement"]
      && !dbFeature.metaData["Placement"].includes(PLACEMENTS.Island)) {
      return false
    }
    return super.load_(dbFeature, new Faucet());
  }

  disabledClick() {
    const centerIslandParent = this.getParent();
    if (!this.disabled && centerIslandParent.cabinet && centerIslandParent.cabinet.disabled) {
      centerIslandParent.cabinet.disabled = false;
      centerIslandParent.cabinet.disabledClick();
    }
    const relatedSink = centerIslandParent.sink;
    if (relatedSink) {
      relatedSink.disabled = this.disabled;
    }
    const stovetop = centerIslandParent.stovetop;
    if (stovetop && !this.disabled && !stovetop.disabled) {
      stovetop.disabled = true;
    }
    const range = centerIslandParent.range;
    if (range && !this.disabled && !range.disabled) {
      range.disabled = true;
    }
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    const featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(true), filteredAvailableFeatures);
    return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  }

  setLayers(layout) {

    const cabinet = this.getParent().cabinet;
    if (cabinet && (cabinet.disabled || !cabinet.featureGroupEnabled)) {
      super.hideLayers();
      return
    }

    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      super.setLayers(layout);
    } else {
      this.setDefault();
      super.setLayers(layout);
    }
  }

  getArrayOfConditions() {
    const sink = this.getParent().sink;
    if (sink && sink.activeFeature) {
      return [{
        propName: "FaucetPlacement",
        propValue: sink.activeFeature.metaData["FaucetPlacement"] || "Moved"
      }]
    }
    return [];
  }

  tryToSetTheSameFeature(filteredFeatures = [], partName = "") {
    if (this.activeFeature && this.activeFeature.partName) {
      const splittedName = (partName || this.activeFeature.partName).split(" M")[0];
      this.activeFeature = filteredFeatures.find(feature => {
        if (feature.partName) {
          const splittedCurrentName = feature.partName.split(" M")[0];
          return splittedCurrentName === splittedName
        }
        return false
      });
      // console.log('AF', filteredFeatures, this.activeFeature);
      if (this.activeFeature) {
        return true
      }
    }
    return false
  }

  setZIndex(zIndexes) {
    if(zIndexes) {
      const zIndex = zIndexes.CenterIsland.Faucet;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndex;
      }
    }
  }
}
